import React, { Component } from 'react';
import XLSX from 'xlsx';
import { withTranslation } from 'react-i18next';
import Container from 'components/v2/container';
import CargomaticModal from 'components/v2/modal';
import CargomaticDropzone from 'components/v2/DropZone';
import CargomaticGrid from 'components/v2/AgGrid';
import ACIZonesStore from 'stores/ACIZonesStore';
import FetchWebAPIUtils from '../../../utils/FetchWebAPIUtils';
const cellClassRules = {
    'bg-red-100': '!x',
    'bg-white': 'x',
};
const requiredFields = {
    CITY: 'CITY_PLACE',
    STATE: 'STATE',
    ZIP: 'ZIP_CODE',
    AIRPORT: 'AIRP_CODE',
    ZONE: 'AREA',
};
const columnDefs = [
    {
        headerName: 'State',
        field: requiredFields.STATE,
        filter: 'agTextColumnFilter',
        width: 125,
        cellClassRules,
        editable: true,
    },
    {
        headerName: 'State Name',
        field: 'StateName',
        filter: 'agTextColumnFilter',
        editable: true,
    },
    {
        headerName: 'Country',
        field: 'Country',
        filter: 'agTextColumnFilter',
        editable: true,
    },
    {
        headerName: 'City',
        field: requiredFields.CITY,
        filter: 'agTextColumnFilter',
        editable: true,
    },
    {
        headerName: 'Zip Code',
        field: requiredFields.ZIP,
        filter: 'agNumberColumnFilter',
        cellClassRules,
        editable: true,
    },
    {
        headerName: 'Airport Code',
        field: requiredFields.AIRPORT,
        filter: 'agTextColumnFilter',
        cellClassRules,
        editable: true,
    },
    {
        headerName: 'Zone',
        field: requiredFields.ZONE,
        filter: 'agTextColumnFilter',
        width: 125,
        cellClassRules,
        editable: true,
    },
];
const requiredDataProvided = (data) => {
    return Object.values(requiredFields).every((field) => data[field]);
};
class ZonesModule extends Component {
    constructor(props) {
        super(props);
        this.onFileDrop = async (file) => {
            if (file.length) {
                const workbook = XLSX.read(await file[0].arrayBuffer(), {
                    type: 'buffer',
                });
                const sheetName = workbook.SheetNames[0];
                const rowData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
                rowData.forEach((row, index) => {
                    row.docId = `${row.StateName}_${index}`;
                    row.isValid = requiredDataProvided(row);
                    return row;
                });
                this.setState({
                    showModal: true,
                    rowData,
                    dataIsValid: rowData.every((row) => row.isValid),
                });
            }
        };
        this.onModalHide = () => {
            this.resetState({ showModal: false });
        };
        this.onUpload = () => {
            const { rowData } = this.state;
            const payload = rowData.map((row) => {
                return {
                    customer_id: '0',
                    city: row[requiredFields.CITY],
                    state: row[requiredFields.STATE],
                    airport_code: row[requiredFields.AIRPORT],
                    postal_code: JSON.stringify(row[requiredFields.ZIP]),
                    zone: row[requiredFields.ZONE],
                };
            });
            FetchWebAPIUtils.upsertACIZones(payload);
            this.setState({ savingData: true }, this.showOverlay);
        };
        this.onCellEdit = (params) => {
            if (params.oldValue !== params.newValue) {
                const { rowData } = this.state;
                const rowIndex = rowData.findIndex((row) => row.docId === params.data.docId);
                if (rowIndex > -1) {
                    const newRow = params.data;
                    newRow.isValid = requiredDataProvided(newRow);
                    rowData.splice(rowIndex, 1, params.data);
                    this.setState({ rowData });
                }
            }
        };
        this.onGridReady = (params) => {
            this.gridAPI = params.api;
        };
        this.getGrid = () => {
            const { t } = this.props;
            const gridStyle = {
                height: '700px',
                width: 'auto',
            };
            return (React.createElement("div", null,
                React.createElement(CargomaticGrid, { columnDefs: this.gridColumns, gridStyles: gridStyle, rowData: this.state.rowData, onGridReady: this.onGridReady, overlayLoadingMessage: `${t('SAVING_ZONES')}...` })));
        };
        this.getModalFooter = () => {
            const { t } = this.props;
            const { dataIsValid, rowData, savingData } = this.state;
            return (React.createElement("div", null,
                React.createElement("button", { className: "button button-green", onClick: this.onUpload, disabled: !rowData.length || !dataIsValid || savingData }, t('UPLOAD'))));
        };
        this.handleUpload = (uploadSuccess) => {
            if (uploadSuccess) {
                this.resetState({
                    showModal: false,
                }, this.hideOverlay);
            }
            else {
                this.setState({
                    savingData: false,
                }, this.hideOverlay);
            }
        };
        this.showOverlay = () => {
            this.gridAPI.showLoadingOverlay();
        };
        this.hideOverlay = () => {
            this.gridAPI.hideOverlay();
        };
        this.assignCellEditFunction = () => {
            return columnDefs.map((col) => {
                return Object.assign(Object.assign({}, col), { onCellValueChanged: this.onCellEdit });
            });
        };
        this.resetState = (additionalState) => {
            this.setState(Object.assign({ dataIsValid: false, rowData: [], savingData: false }, additionalState), this.hideOverlay);
        };
        this.showModal = () => {
            const { t } = this.props;
            if (this.state.showModal && this.state.rowData.length) {
                return (React.createElement(CargomaticModal, { show: true, showCloseButton: true, onHide: this.onModalHide, title: t('ACI_ZONES'), location: "middle", dialogClassName: "modal-grid", body: this.getGrid(), footer: this.getModalFooter() }));
            }
            return null;
        };
        this.state = {
            dataIsValid: false,
            rowData: [],
            showModal: true,
            savingData: false,
        };
        this.gridColumns = this.assignCellEditFunction();
    }
    componentDidMount() {
        ACIZonesStore.addChangeListener(this.handleUpload);
    }
    componentWillUnmount() {
        ACIZonesStore.removeChangeListener(this.handleUpload);
    }
    render() {
        const dropzoneStyle = {
            display: 'flex',
            height: '50px',
            width: 'auto',
            border: '2px dashed black',
            borderRadius: '4px',
        };
        const { t } = this.props;
        return (React.createElement(Container, null,
            React.createElement("div", { className: "min-h-screen mt-10" },
                React.createElement("h2", { className: "my-0 mb-4" }, t('ZONES')),
                React.createElement("div", { style: { width: '300px' } },
                    React.createElement(CargomaticDropzone, { onDrop: this.onFileDrop, multiple: false, style: dropzoneStyle, dropzoneMessage: t('CLICK_DROP_FILE_TO_UPLOAD') }),
                    this.showModal()))));
    }
}
export default withTranslation()(ZonesModule);
